import { Interactor, InteractorType } from "../core/tool/Interactor";
import { InteractorManager } from "../core/tool/InteractorManager";
export class SubArticleHighlight extends Interactor {
    get article() {
        return (this.mArticle);
    }
    constructor(pSubArticle, pManager) {
        super(document.createElement("div"), pManager.app.viewer);
        this.mArticle = pSubArticle;
        this.type = InteractorType.None;
        //position
        this.customCssTransform = "translate(-50%, -50%)";
        this.worldMatrix = this.mArticle.worldTransform;
        this.position.copyFrom(this.mArticle.boundingBoxVisible.getCenter());
    }
}
/** @internal */
export class SubArticleHighlights {
    static Create(pArticle, pManager, pCreateCallback, pDisposeCallback) {
        if (pManager.app.tools.defaultTool != null && !pManager.app.tools.isDefaultToolRunning())
            return (null);
        return (new SubArticleHighlights(pArticle, pManager, pCreateCallback, pDisposeCallback));
    }
    dispose() {
        //dispose disables the interactor manger
        if (this.mInteractors.enabled) {
            //deregister events
            this.mMngr.app.model.eventSelectionChanged.removeListener(this.onSelectionChanged);
            this.mMngr.app.tools.eventToolStarted.removeListener(this.onToolStart);
            if (this.notifyDispose != null) {
                this.notifyDispose();
            }
            this.mInteractors.dispose();
        }
    }
    constructor(pArticle, pManager, pCreateCallback, pDisposeCallback) {
        this.onSelectionChanged = () => {
            this.dispose();
        };
        this.onToolStart = () => {
            this.dispose();
        };
        this.mMngr = pManager;
        this.mArticle = pArticle;
        this.mInteractors = new InteractorManager(this.mMngr.app.viewer);
        this.notifyDispose = pDisposeCallback;
        //register events
        this.mMngr.app.model.eventSelectionChanged.addListener(this.onSelectionChanged);
        this.mMngr.app.tools.eventToolStarted.addListener(this.onToolStart);
        this.mMngr.app.model.eventSelectionChanged.addListener(this.onSelectionChanged);
        this.createHighlights(pCreateCallback);
    }
    createHighlights(pCreateCallback) {
        const tSubArticles = this.mArticle.getSubArticles(false);
        const tHighlights = new Array();
        for (const tSub of tSubArticles) {
            if (!tSub.canSelect() || !tSub.boundingBoxVisible.isValid())
                continue;
            const tHighlight = new SubArticleHighlight(tSub, this.mMngr);
            this.mInteractors.addInteractor(tHighlight);
            tHighlights.push(tHighlight);
        }
        pCreateCallback(tHighlights);
    }
}
